'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import newsletterSignupAction from '@/app/_lib/actions/NewsletterSignupAction';
import FormError from '@/app/_components/FormError';
import RecaptchaDisclaimer from '@/app/_components/RecaptchaDisclaimer';
import { useGlobalMessage } from '@/app/_lib/hooks';
import { useReCaptcha } from 'next-recaptcha-v3';
import { trackNewsletterSignup } from '@/app/_lib/analytics/ga4';
const initialFormState = {
  message: false,
  messages: [],
  errors: {
    email: false
  }
};
const FooterNewsletterSignup = () => {
  const addGlobalMessage = useGlobalMessage();
  const {
    executeRecaptcha
  } = useReCaptcha();
  let [serverResponse, setServerResponse] = useState(initialFormState);
  let [isPending, setIsPending] = useState(false);
  let [email, setEmail] = useState('');
  const handleSubmit = async e => {
    e.preventDefault();
    console.log('DEBUG FooterNewsletterSignup: Form submitted');
    setIsPending(true);

    // Capture form data before any async operations
    const formData = new FormData(e.target);
    try {
      // Get reCAPTCHA token
      console.log('DEBUG FooterNewsletterSignup: Calling executeRecaptcha...');
      const token = await executeRecaptcha('newsletter_signup');
      console.log('DEBUG FooterNewsletterSignup: reCAPTCHA token:', token ? `${token.substring(0, 20)}...` : 'FAILED');
      if (!token) {
        addGlobalMessage({
          message: 'Please try again in a moment.',
          messageType: 'error'
        });
        setIsPending(false);
        return;
      }
      formData.set('recaptcha_token', token);
      const response = await newsletterSignupAction(formData);
      setServerResponse(response);

      // Show global message
      if (response.success) {
        trackNewsletterSignup();
        addGlobalMessage({
          message: response.message,
          messageType: 'success'
        });
        // Clear the form on success
        setEmail('');
        setServerResponse(initialFormState);
      } else {
        addGlobalMessage({
          message: response.message || 'Newsletter signup failed. Please try again.',
          messageType: 'error'
        });
      }
    } catch (error) {
      addGlobalMessage({
        message: 'An error occurred. Please try again.',
        messageType: 'error'
      });
    } finally {
      setIsPending(false);
    }
  };
  return <div className="min-h-[75px] h-full ">
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <div className="material-input-group mb-2">
                        <input type="email" id="footer_newsletter_singup_email" name="email" value={email} onChange={e_0 => setEmail(e_0.target.value)} autoComplete="email" className="material-input peer pr-8" placeholder=" " disabled={isPending} />
                        <label htmlFor="footer_newsletter_singup_email" className="material-input-label peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-not-placeholder-shown:material-input-label-float text-ink-muted">Email</label>
                        <button type="submit" disabled={isPending} aria-label="Subscribe to newsletter" className="absolute right-0 top-1/2 -translate-y-1/2 px-2 text-light-3 hover:text-primary transition-colors disabled:opacity-50">
                            <FontAwesomeIcon icon={faChevronRight} size="xs" aria-hidden="true" />
                        </button>
                    </div>
                    <FormError addClasses="text-2xs">{serverResponse?.errors?.email}</FormError>
                </div>
                <div className="text-3xs text-muted mb-3">By providing this information, you are opting to receive email communications from hive. <Link href="/hive-modern-privacy-policy" className="underline hover:text-primary">View privacy policy.</Link></div>
                <RecaptchaDisclaimer addClasses="text-3xs" />
            </form>
        </div>;
};
export default FooterNewsletterSignup;